var r={};export{r as __exports};
//# sourceMappingURL=index2.js.map
